export default __webpack_public_path__ + "static/media/shareRight@2x.f4295aa7.png";